/**
 * GameHUD component - displays game stats
 */

import type { GameStats } from '../utils/types';

interface GameHUDProps {
  stats: GameStats;
}

export function GameHUD({ stats }: GameHUDProps) {
  return (
    <div className="game-hud">
      <div className="hud-panel">
        <div className="hud-item">
          <span>🎯</span>
          <span>Level {stats.level}</span>
        </div>
        <div className="hud-item">
          <span>🏆</span>
          <span>{stats.score}</span>
        </div>
      </div>

      <div className="hud-panel">
        <div className="hud-item">
          <span>⚠️</span>
          <span>{stats.strikes}/3</span>
        </div>
      </div>
    </div>
  );
}
